import * as React from "react";

function SvgDropFile(props) {
  return <svg width={56} height={48} viewBox="0 0 58 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.3 0C5.376 0 3.508.73 2.15 2.134.792 3.482 0 5.335 0 7.244v57.511c0 1.91.736 3.763 2.15 5.11A7.359 7.359 0 007.3 72h43.457c1.924 0 3.791-.73 5.093-2.134 1.358-1.348 2.15-3.201 2.15-5.11v-43.19L36.271 0H7.3zm0 7.189h25.35V25.16h18.107v39.538H7.3V7.189z" fill="#000" fillOpacity={0.54} /></svg>;
}

export default SvgDropFile;